import ArticleCard from '@/components/base/ArticleCard';
import { articles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const featured = articles.filter((a) => a.isFeatured);

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-10">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
          热门推荐
        </h2>
        <span className="text-xs text-foreground-500 bg-background-100 px-3 py-1 rounded-full">
          实时更新
        </span>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-5" data-product-shop="">
        {featured.map((article) => (
          <ArticleCard key={article.slug} {...article} />
        ))}
      </div>
    </section>
  );
}